import { render, staticRenderFns } from "./refundPolicy.vue?vue&type=template&id=d1721df6&scoped=true&"
import script from "./refundPolicy.vue?vue&type=script&lang=js&"
export * from "./refundPolicy.vue?vue&type=script&lang=js&"
import style0 from "./refundPolicy.vue?vue&type=style&index=0&id=d1721df6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1721df6",
  null
  
)

export default component.exports